export enum TILES_APP_LOCATION {
  STANDALONE = "Standalone",
  DASHBOARD = "Dashboard",
  DASHBOARD_PREVIEW = "Dashboard Preview"
}

export const SELLER_ADDRESS_LOCALSTORAGE_KEY = "seller-address";
export const LATEST_ATTEMPTED_QUIZ_ANSWERS_LOCALSTORAGE_KEY = "quizzes-answers";
export const CALENDELY_SCHEDULER_LOCALSTORAGE_KEY = "calendly-scheduler";
